import type { HTMLAttributes, ReactElement } from 'react';
import styles from '../popup.module.css';

export function PopupBadge({ children }: HTMLAttributes<HTMLDivElement>): ReactElement {
  return <div className={styles.badge}>{children}</div>;
}
